import { FC } from 'react'
import s from './DailyCard.module.sass'
import IconDaily from '@icons/icon-afisha-daily-white.svg'
import { BaseCard } from '@shared/ui/Layout/Cards/BaseCard'

interface Props {
  id?: number | string
  title: string
  url: string
  img?: string | null
}

const DailyCard: FC<Props> = ({ id, title, url, img }) => {
  return (
    <BaseCard sizes='L ML' href={url}>
      <BaseCard.Media image={{ id, src: img, alt: `Daily: ${title}` }} className={s.img}>
        <IconDaily className={s.logo} />
      </BaseCard.Media>

      <BaseCard.Content>
        <BaseCard.Title href={url} title={title}>
          {title}
        </BaseCard.Title>
      </BaseCard.Content>
    </BaseCard>
  )
}

export default DailyCard
